import { IconAnalytics } from '~/design-system';
import type { ModuleDefinition } from '~/platform/registry/types';

export const analyticsModule: ModuleDefinition = {
  id: 'analytics',
  i18nNamespace: 'analytics',
  requires: { subject: 'analytics', action: 'read' },

  nav: {
    labelKey: 'analytics:nav',
    icon: IconAnalytics,
    to: 'analytics',
    group: 'money',
    order: 30,
  },

  routes: [{ path: 'analytics', component: () => import('./AnalyticsPage') }],
};
